module.exports = __webpack_public_path__ + "static/img/productimg4.e4963e69.png";